import { FC } from 'react';
import SummaryCard from '../../../../components/shared/Charts/SummaryCard/SummaryCard';
import { useTranslation } from 'react-i18next';

type Props = {
  value: number;
}

const ActiveNextIntegrationsCard: FC<Props> = ({ value }) => {
  const [t] = useTranslation('dashboard');
  return (
    <SummaryCard
      title={t('activeNextIntegrations', 'Aktiva Next-integrationer')}
      value={value}
      infoText={t('activeNextIntegrationsTip', 'Antal organisationer med en aktiv Next-integration')}
    />
  );
}

export default ActiveNextIntegrationsCard;
